export default "{\n    \"hiddenOptionsWarningText\": \"No se muestran todas las opciones, busque para filtrar.\"\n}\n"